const component = require('../component/component');

const modal = Object.assign({}, component, {
    // Structural subelements discovered inside the leaf-provided modal
    // template by their data-zit-subelement-type markers. The leaf owns
    // the markup (Bootstrap-shaped under metronic_8); base JS reaches
    // in via these neutral markers instead of hardcoded class selectors.
    subelements: {
        dialog: null,
        title: null,
        body: null,
        footer: null
    },
    modalObj: false,

    init: function () {
        let modalHTML = this.hm.helper.getTemplate('zit-modal');
        this.element = this.hm.helper.string2element(modalHTML);
        document.body.append(this.element);

        // Discover the structural subelements within the rendered template.
        // The standard initSubelements() walks the document for
        // data-zit-subelement-for=<id>, but the modal element is dynamically
        // created and not yet attached to a component-id scope — query the
        // element subtree directly by data-zit-subelement-type.
        this.subelements.dialog = this.element.querySelector('[data-zit-subelement-type="dialog"]');
        this.subelements.title = this.element.querySelector('[data-zit-subelement-type="title"]');
        this.subelements.body = this.element.querySelector('[data-zit-subelement-type="body"]');
        this.subelements.footer = this.element.querySelector('[data-zit-subelement-type="footer"]');

        // Construct the modal via the theme's behaviour adapter (the contract
        // returns the same { show, hide, dispose } surface bootstrap.Modal
        // exposes today). bootstrap5 wraps bootstrap.Modal directly;
        // metronic_8 inherits unchanged.
        this.modalObj = this.hm.behaviors.modal.create(this.element);
    },

    setSize: function (size) {
        ['modal-lg', 'modal-sm', 'modal-xl'].forEach((alreadySize) => {
            if (this.subelements.dialog.classList.contains(alreadySize)) {
                this.subelements.dialog.classList.remove(alreadySize);
            }
        });

        switch (size) {
            case 'lg':
            case 'large':
                size = 'modal-lg';
                break;

            case 'sm':
            case 'small':
                size = 'modal-sm';
                break;

            case 'xl':
            case 'extra':
                size = 'modal-xl';
                break;

            default:
                size = false;
        }

        if (size !== false) {
            this.subelements.dialog.classList.add(size);
        }
    },

    initForm: function (formId, action, method, enctype) {
        if (typeof action === typeof undefined) {
            action = '';
        }

        if (typeof method === typeof undefined) {
            method = 'POST';
        }

        if (typeof enctype === typeof undefined) {
            enctype = 'multipart/form-data';
        }

        let formEl = this.element.querySelector('form');

        formEl.id = formId;
        formEl.action = action;
        formEl.method = method;
        formEl.enctype = enctype;
    },

    setTitle: function (title) {
        this.subelements.title.innerHTML = title;
    },

    setContent: function (modalInnerHTML) {
        this.subelements.body.innerHTML = modalInnerHTML;
    },

    appendContent: function (contentElement) {
        this.subelements.body.appendChild(contentElement);
    },

    addActions: function (actions, position = 'right') {
        let footerElement = this.subelements.footer;
        let leftActionPosition = footerElement.querySelector('[data-zit-actions-position="left"]');
        let rightActionPosition = footerElement.querySelector('[data-zit-actions-position="right"]');

        let parentElement = footerElement;

        if (position === 'right' && rightActionPosition !== null) {
            parentElement = rightActionPosition;
        } else if (position === 'left' && leftActionPosition !== null) {
            parentElement = leftActionPosition;
        }

        if (this.hm.helper.isArray(actions)) {
            actions.forEach((action) => {
                this.hm.app.addAction(action, parentElement, true);
            });
        } else if (this.hm.helper.isObject(actions)) {
            for (let actionName in actions) {
                this.hm.app.addAction(actions[actionName], parentElement, true);
            }
        }
    },

    addAction: function (action) {
        this.hm.app.addAction(action, this.subelements.footer, true);
    },

    open: function () {
        if (this.modalObj !== false) {
            this.modalObj.show();
        }
    },

    close: function () {
        if (this.modalObj !== false) {
            this.modalObj.hide();
        }
    },

    dispose: function () {
        if (this.modalObj !== false) {
            this.modalObj.dispose();
            this.modalObj = false;
            this.element.remove();
        }
    }
});

module.exports = modal;